import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { moduleRegistry } from '../modules/moduleRegistry';
import { useIsMobile } from '../hooks/useIsMobile';
export const Navigation = ({ isOpen = true }) => {
    const isMobile = useIsMobile();
    const authenticatedModules = moduleRegistry.filter((m) => m.requiresAuth);
    if (isMobile)
        return null;
    return (_jsx("nav", { style: { ...styles.nav, display: isOpen ? 'block' : 'none' }, children: _jsxs("div", { style: styles.navContent, children: [_jsx("h3", { style: styles.navTitle, children: "Menu" }), _jsx("ul", { style: styles.navList, children: authenticatedModules.map((module) => (_jsx("li", { style: styles.navItem, children: _jsxs(Link, { to: module.path, style: styles.navLink, children: [module.icon && _jsx("span", { style: styles.icon, children: module.icon }), module.name] }) }, module.id))) })] }) }));
};
const styles = {
    nav: {
        backgroundColor: 'rgba(255, 255, 255, 0.4)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderRight: '1px solid rgba(0, 0, 0, 0.08)',
        width: '250px',
        minHeight: 'calc(100vh - 70px)',
    },
    navContent: {
        padding: '24px 0',
    },
    navTitle: {
        padding: '0 24px',
        margin: '0 0 16px 0',
        fontSize: '11px',
        fontWeight: '700',
        color: '#86868b',
        textTransform: 'uppercase',
        letterSpacing: '0.1em',
    },
    navList: {
        listStyle: 'none',
        padding: 0,
        margin: 0,
    },
    navItem: {
        margin: 0,
    },
    navLink: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '12px 24px',
        color: '#1d1d1f',
        textDecoration: 'none',
        transition: 'all 0.2s ease',
        fontSize: '15px',
        fontWeight: '500',
    },
    icon: {
        fontSize: '18px',
    },
};
//# sourceMappingURL=Navigation.js.map